import Axios from 'axios'

const preferences = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  loadPreferences () {
    return this.callUserPreferences().then((response) => {
      return response.data
    })
  },
  callUserPreferences () {
    return this.axios().get('/manage/user-preference/preferences')
  },
  saveUserPreferences (preferences) {
    return this.axios().put('/manage/user-preference', preferences)
  },
  getPreferencesOptions () {
    return this.axios().get('/manage/user-preference/fields-values')
  }
}

export default preferences
